import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import { ArrowBack } from "@mui/icons-material";
import rodrimaq_icon from '../../assets/img/Alternative_logo.png';
import { Calendario } from "./Calendario";
import ScheduleIcon from '@mui/icons-material/Schedule';
import { ModalPin } from "./ModalPin";


export function PicaPonto() {

    const [modalPinOpen, setModalPinOpen] = useState(false);
    const [currentDate, setCurrentDate] = useState(new Date(Date.now()).toLocaleString('pt').split(',')[0]);
    const [currentHour, setCurentHour] = useState<string | null>(null);
    const [currentMinute, setCurrentMinute] = useState<string | null>(null);
    const [currentSeconds, setCurrentSeconds] = useState<string | null>(null);

    const [dataDePicagem, setDataDePicagem] = useState<null | Date>(null);
    const [evento, setEvento] = useState<null | string>(null);

    useEffect(() => {
        localStorage.setItem('modo-pica-ponto', 'sim');
        setInterval(() => {
            const ct = new Date(Date.now()).toLocaleString('pt').split(', ');
            const date = ct[0];
            const hour = ct[1];
            const hours = hour.split(':')[0];
            const minutes = hour.split(':')[1];
            const seconds = hour.split(':')[2];
            setCurentHour(hours);
            setCurrentMinute(minutes);
            setCurrentSeconds(seconds);
            setCurrentDate(date);
        }, 10000)
    }, [])


    const handleClickEvento = (event: string) => {
        setDataDePicagem(new Date(Date.now()));
        setModalPinOpen(true);
        setEvento(event);
    }


    return (<div className="fixed top-0 right-0 flex flex-col w-full h-screen bg-rodrimaq-red-medium p-6 overflow-hidden">
        {modalPinOpen && dataDePicagem && evento ? <ModalPin evento={evento} dataPicagem={dataDePicagem} close={() => {
            setDataDePicagem(null);
            setModalPinOpen(false);
            setEvento(null);
        }} /> : null}
        <div className="flex flex-col w-full h-full bg-white p-4 rounded-2xl">
            <div className="flex w-full justify-between">
                <div className="flex items-center">
                    <ArrowBack className="mr-5 text-rodrimaq-red-medium cursor-pointer" />
                    <div className="text-rodrimaq-red text-[2em] font-bold">PICAGEM DE PONTO</div>
                </div>

                <img src={rodrimaq_icon} width={40} height={40} />
            </div>
            <div className="grid grid-cols-3 gap-4 mt-5">
                <div className="col-span-1">
                    <Calendario date={currentDate} />
                </div>
                <div className="col-span-2 pl-20 flex w-full items-center">

                    <div className="text-[3em] flex w-fit items-center font-bold border border-cyan-800 rounded-3xl p-10 px-10 shadow-xl text-cyan-800 bg-gray-200">
                        <ScheduleIcon style={{ fontSize: '1.2em' }} className="mr-4" />
                        <div>
                            {currentHour} : {currentMinute}
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex  items-center mt-6">

                <button onClick={() => handleClickEvento('Entrada')} className="flex w-full border-2 rounded-2xl py-6 border-rodrimaq-red  shadow-2xl justify-center m-4 focus:bg-rodrimaq-red focus-text-white">
                    <div className="text-[1.5em] font-bold">Entrada</div>
                </button>
                <button onClick={() => handleClickEvento('Saida')} className="flex w-full border-2 rounded-2xl py-6 border-rodrimaq-red  shadow-2xl justify-center m-4 focus:bg-rodrimaq-red focus-text-white">
                    <div className="text-[1.5em] font-bold">Saída</div>
                </button>
            </div>
        </div>
    </div>)

}